import { useQuery } from '@tanstack/react-query';
import { fetchProjects } from '../api/projects';
import type { Project } from '@deposits/shared';

export function useProjects(enabled: boolean) {
  return useQuery<Project[]>({
    queryKey: ['projects'],
    queryFn: fetchProjects,
    enabled,
    staleTime: 5 * 60 * 1000, // new projects appear rarely
  });
}
